

















































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringTrombolisisKpiHeader from "./MonitoringTrombolisisKpiHeader.vue";
import MonitoringTrombolisisSetup from "./MonitoringTrombolisisSetup.vue";
import MonitoringTrombolisisLogTimeline from "./MonitoringTrombolisisLogTimeline.vue";
import MonitoringTrombolisisOutcome from "./MonitoringTrombolisisOutcome.vue";
import MonitoringTrombolisisSvc from "@/services/MonitoringTrombolisisService";

@Component({
  components: {
    MonitoringTrombolisisKpiHeader,
    MonitoringTrombolisisSetup,
    MonitoringTrombolisisLogTimeline,
    MonitoringTrombolisisOutcome,
  }
})
export default class MonitoringTrombolisisDetail extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) monitoringData!: any;

  monitoring: any = null;
  openPanels: number[] = [0];

  mounted() {
    if (this.monitoringData) {
      this.monitoring = this.monitoringData;
      if (this.monitoring.id) {
        this.refreshData(this.monitoring.id);
      }
    }
  }

  get isNew() {
    return !this.monitoring || !this.monitoring.id;
  }

  get isLocked() {
    return this.monitoring?.is_locked || false;
  }

  async refreshData(id: number) {
    try {
      const resp = await MonitoringTrombolisisSvc.find(id);
      if (resp?.data?.status == "1") {
        this.monitoring = resp.data.data;
      }
    } catch {
      // handled
    }
  }

  async onSaved(data?: any) {
    if (data?.id) {
      await this.refreshData(data.id);
      // Open panel 2 after initial save
      if (!this.openPanels.includes(1)) {
        this.openPanels.push(1);
      }
    }
    this.$emit("saved");
  }

  cetakPdf() {
    if (this.monitoring?.id) {
      MonitoringTrombolisisSvc.printPdf(this.monitoring.id);
    }
  }
}
